// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qvtrd","questions":"styles_questions__cN97d","footer":"styles_footer__23R-6"};